import PropTypes from "prop-types"
import usePositionTooltip from "connected-components/dashboard/helpers/tooltips"
import PositionTooltip from "components/position-tooltip"
import CellTooltip from "components/securities-table/cell-tooltip"

export default function ContributorsTableTooltip({ children, item }) {
  const positionTooltip = usePositionTooltip(item)
  if (!item) {
    return null
  }

  const tooltipValue = item.tooltipValue
  if (tooltipValue) {
    return <div style={{ display: "flex", alignItems: "center" }}>{children}<CellTooltip contents={tooltipValue} /></div>
  }

  if (!positionTooltip || item.id === "notheld") {
    return children
  }

  const isActive = positionTooltip.isActive

  return <PositionTooltip position={positionTooltip} classes={{ popper: "security-description-container force", tooltip: "security-description" }} isActive={isActive}>{children}</PositionTooltip>
}

ContributorsTableTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  item: PropTypes.object.isRequired,
}
